/**
 * Application-wide constants. Anything magic — keys, routes, event names —
 * lives here so search-and-replace is a one-stop operation.
 */

export const STORAGE_KEYS = Object.freeze({
  cart: 'kiddocorner_cart',
  wishlist: 'kiddocorner_wishlist',
  promoBannerDismissed: 'kiddocorner_promo_dismissed',
  recentSearches: 'kiddocorner_recent_searches',
  accessToken: 'kiddocorner_access_token',
  refreshToken: 'kiddocorner_refresh_token',
  authUser: 'kiddocorner_auth_user',
})

export const ROUTES = Object.freeze({
  home: '/',
  shop: '/shop',
  product: (slug) => `/product/${slug}`,
  cart: '/cart',
  checkout: '/checkout',
  orderConfirmation: (orderNumber) => `/order/${orderNumber}`,
  trackOrder: '/track',
  wishlist: '/wishlist',
  about: '/about',
  contact: '/contact',
  returnPolicy: '/return-policy',
  login: '/login',
  adminDashboard: '/admin',
  adminProducts: '/admin/products',
  adminOrders: '/admin/orders',
  adminOrderDetail: (id) => `/admin/orders/${id}`,
  adminInventory: '/admin/inventory',
  adminCategories: '/admin/categories',
  adminCustomers: '/admin/customers',
  adminReviews: '/admin/reviews',
  adminBanners: '/admin/banners',
  adminSubscribers: '/admin/subscribers',
  adminSettings: '/admin/settings',
  packer: '/packer',
  packerOrder: (id) => `/packer/orders/${id}`,
})

/** Order lifecycle, mirrored from the backend's OrderStatus enum. */
export const ORDER_STATUS = Object.freeze({
  PENDING: 'PENDING',
  CONFIRMED: 'CONFIRMED',
  PROCESSING: 'PROCESSING',
  SHIPPED: 'SHIPPED',
  DELIVERED: 'DELIVERED',
  CANCELLED: 'CANCELLED',
})

/** Courier shipment lifecycle, mirrored from the backend's ShipmentStatus enum. */
export const SHIPMENT_STATUS = Object.freeze({
  QUEUED: 'QUEUED',
  DISPATCHING: 'DISPATCHING',
  CREATED: 'CREATED',
  IN_TRANSIT: 'IN_TRANSIT',
  DELIVERED: 'DELIVERED',
  PARTIAL_DELIVERED: 'PARTIAL_DELIVERED',
  CANCELLED: 'CANCELLED',
  FAILED: 'FAILED',
})

export const SORT_OPTIONS = Object.freeze([
  { value: 'featured', label: 'Featured' },
  { value: 'price-asc', label: 'Price: Low to High' },
  { value: 'price-desc', label: 'Price: High to Low' },
  { value: 'newest', label: 'Newest' },
  { value: 'rating', label: 'Top Rated' },
])

export const VIEW_MODES = Object.freeze({ grid: 'grid', list: 'list' })

export const PRICE_RANGE = Object.freeze({ min: 0, max: 5000 })
